// extracted by mini-css-extract-plugin
export default {"link":"MarketRequestsLinkWidget_link__vAkog"};